export default __webpack_public_path__ + "static/media/dreamstime_s_66614814.64a6744a.jpg";